'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const{DataSet:DataSet,Timeline:Timeline}=require('vis-timeline');
const fastdom=require('fastdom');
const Formatters=require('../../../../dist-es6/client/formatters');
const moment=require('pulsar-utils/dist-es6/time/moment');
const TimeInterval=require('pulsar-utils/dist-es6/timeInterval');
const timespan=require('pulsar-utils/dist-es6/time/timespan');
const{ScheduleRowDirectiveController:ScheduleRowDirectiveController}=require('../../../../dist-es6/client/directives/scheduleRowDirective/scheduleRowDirective');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');

const AxisHeight=23;
const ScheduleRowHeight=41;

const DefaultMaxSchedulesToDisplay=Infinity;let

MultiForecastRowDirective=function(_BaseControllerBacked){_inherits(MultiForecastRowDirective,_BaseControllerBacked);function MultiForecastRowDirective(){_classCallCheck(this,MultiForecastRowDirective);return _possibleConstructorReturn(this,_BaseControllerBacked.apply(this,arguments))}_createClass(MultiForecastRowDirective,[{key:'template',get:function()
{return''}},{key:'objectBindings',get:function()

{return['forecastSchedules','selectedSchedule','currentTime','axisBounds','incidentTypesByCode','maxSchedulesToDisplay']}},{key:'$inject',get:function()

{return['$scope','$timeout','$element','$animate','$compile','timeZoneService','scheduleRowScrollingService']}},{key:'controller',get:function()

{return MultiForecastRowController}}]);return MultiForecastRowDirective}(BaseControllerBackedDirective);let


MultiForecastRowController=function(_ScheduleRowDirective){_inherits(MultiForecastRowController,_ScheduleRowDirective);
function MultiForecastRowController($scope,$timeout,$element,$animate,$compile,timeZoneService,scheduleRowScrollingService,timeFormattingService){_classCallCheck(this,MultiForecastRowController);var _this2=_possibleConstructorReturn(this,
_ScheduleRowDirective.call(this,$scope,$timeout,$element,$animate,timeZoneService,scheduleRowScrollingService));
_this2.selectedSchedule=_this2.selectedSchedule||null;
_this2.maxSchedulesToDisplay=_this2.maxSchedulesToDisplay||DefaultMaxSchedulesToDisplay;
_this2._timeFormattingService=timeFormattingService;

if(_this2.maxSchedulesToDisplay===Infinity){
console.warn('[MultiForecastRowController] maxSchedulesToDisplay is "Infinity" and should be limited to reduce likelihood of performance impact.');
}

_this2._$compile=$compile;return _this2;
}MultiForecastRowController.prototype.

_setupTimeline=function _setupTimeline(){var _this3=this;
_ScheduleRowDirective.prototype._setupTimeline.call(this);
this._timeline.setOptions({
orientation:'top',
timeAxis:{
scale:'hour',
step:2},

margin:16,
showCurrentTime:!0,
showMinorLabels:!0,
format:{
minorLabels:function(date,scale,step){
const zonedMoment=_this3._momentWithTimeZoneForTimeline(date);
const format=_this3._timeFormattingService.safeUse24HourTimelineSetting?
'HH:mm':
zonedMoment.hours()%12==0?
'hA':
'h:mm';

return zonedMoment.format(format);
}}});



this._resetCurrentTime();

this._timelineElement=angular.element(this._$element).find('> .vis-timeline');
this._timelineElement.append(`<div id="group-outline" class="group-outline"></div>`);
this._timelineElement.append(`<div id="selected-group-outline" class="group-outline selected"></div>`);

this._hoveredGroupOutlineElement=angular.element('#group-outline');
this._selectedGroupOutlineElement=angular.element('#selected-group-outline');

this._timeline.on('click',function(event){
_this3._$scope.$evalAsync(function(){
const selectedSchedule=_this3.forecastSchedules[_.get(event,'group',-1)];
_this3.selectedSchedule=selectedSchedule||null;
_this3._moveElementToSchedule(_this3._selectedGroupOutlineElement,selectedSchedule);
});
});

const debouncedUpdateHoveredGroup=_.debounce(function(event){
if(!_this3._hoveredGroupOutlineElement){
return;
}

if(_.exists(event.group)){
_this3._moveElementToSchedule(_this3._hoveredGroupOutlineElement,_this3.forecastSchedules[_.get(event,'group',-1)]);
return;
}

if(event.currentTarget&&_.get(event,'originalEvent.path',[]).find(function(p){return _.get(p,'tagName')==='PULSAR-MULTI-FORECAST-ROW'})!==void 0){
return;
}

_this3._hideElement(_this3._hoveredGroupOutlineElement);
},6,{maxWait:6,leading:!0,trailing:!0});

this._timeline.on('changed',function(){return _this3._resetCurrentTime()});

this._timeline.on('mouseMove',debouncedUpdateHoveredGroup);
angular.element(document).on('mousemove',debouncedUpdateHoveredGroup);

this._$scope.$on('$destroy',function(){
_this3._timeline.off('click');
_this3._timeline.off('mouseMove');

angular.element(document).off('mousemove',debouncedUpdateHoveredGroup);

_this3._destroyChildScopes();
});
};MultiForecastRowController.prototype.

_hideElement=function _hideElement(element){
if(!_.exists(element)){
return;
}

fastdom.mutate(function(){
element.css({display:'none'});
});
};MultiForecastRowController.prototype.

_moveElementToSchedule=function _moveElementToSchedule(element,group){
if(!_.exists(element)){
return;
}

if(!group){
this._hideElement(element);
return;
}

const index=(this.forecastSchedules||[]).indexOf(group);

if(!this.forecastSchedules||index===-1||index>=Math.min(this.forecastSchedules.length,this.maxSchedulesToDisplay)){
this._hideElement(element);
return;
}

fastdom.mutate(function(){
element.css({
display:'block',
transform:`translateY(${index*ScheduleRowHeight}px)`});

});
};MultiForecastRowController.prototype.

_updateData=function _updateData(){
const groups=new DataSet([]);
const items=new DataSet([{
id:'past-mask',
start:this.axisBounds.start,
end:this.currentTime,
type:'background',
className:'past-mask'}]);



const numSchedulesToProcess=Math.min(this.forecastSchedules.length,this.maxSchedulesToDisplay);

const height=AxisHeight+(numSchedulesToProcess||1)*ScheduleRowHeight+'px';

if(!this.forecastSchedules||numSchedulesToProcess===0){
this._setTimelineData({groups:groups,items:items,height:height});
return;
}

const currentTimeAsEncodedInterval=encodeURIComponent(`${this.currentTime.toISOString()}-to-${this.currentTime.toISOString()}`);
const encodedCurrentTimeZone=encodeURIComponent(this._timeZoneService.localTimeZone);

for(let index=0;index<numSchedulesToProcess;index++){
groups.add({
id:index,
content:`
                <div class="person-label" layout="column">
                    <pulsar-current-duty-status person-view-model="controller.forecastSchedules[${index}]"></pulsar-current-duty-status>
                    <a class="name" href="${this.forecastSchedules[index].viewSchedule({asString:!0})}">${this.forecastSchedules[index].name}</a>
                    ${this.forecastSchedules[index].timeOfLastPointBeforeTruncation?'<span class="is-stale" title="Invalid data detected."></span>':''}
                </div>
                `});

items.add(this._getTimelineDataFor(this.forecastSchedules[index],index));
}

this._setTimelineData({groups:groups,items:items,height:height});
};MultiForecastRowController.prototype.

_setTimelineData=function _setTimelineData(_ref){var _this4=this;let{groups:groups,items:items,height:height}=_ref;
this._resetCurrentTime();
this._timeline.setData({groups:groups,items:items});
this._timeline.setOptions({height:height});

this._destroyChildScopes();
this._childScopes=new Set;
this._$element.find('pulsar-current-duty-status').each(function(index,el){
const childScope=_this4._$scope.$new();
_this4._childScopes.add(childScope);

_this4._$compile(el)(childScope,function(compiled){
_this4._$scope.$evalAsync(function(){
angular.element(el).replaceWith(compiled);
});
childScope.$on('$destroy',function(){
compiled.remove();
});
});
});
};MultiForecastRowController.prototype.

_resetCurrentTime=function _resetCurrentTime(){
this._timeline.setCurrentTime(this.currentTime);
this._timeline.currentTime.stop();
};MultiForecastRowController.prototype.

_destroyChildScopes=function _destroyChildScopes(){
if(this._childScopes){
for(const scope of this._childScopes){
scope.$destroy();
}
}
};MultiForecastRowController.prototype.

_setupWatchers=function _setupWatchers(){var _this5=this;
this._$scope.$watch('controller.forecastSchedules',function(){
_this5._moveElementToSchedule(_this5._selectedGroupOutlineElement,_this5.selectedSchedule);
_this5._redraw();
});
this._$scope.$watch('controller.selectedSchedule',function(){return _this5._moveElementToSchedule(_this5._selectedGroupOutlineElement,_this5.selectedSchedule)});
};MultiForecastRowController.prototype.

_getTimelineDataFor=function _getTimelineDataFor(forecastSchedule,groupId){var _this6=this;
const{incidents:incidents,scenario:scenario,predictedWorkday:predictedWorkday,visibleAlertRanges:visibleAlertRanges,alertRanges:alertRanges,combinedDuties:combinedDuties}=forecastSchedule;

let newData=[];

if(scenario&&visibleAlertRanges){
if(_.exists(predictedWorkday)){
newData.push({
id:'forecasted-duty',
start:predictedWorkday.start,
end:predictedWorkday.end,
className:`forecasted-duty`});

}

newData=newData.concat(
_getNamedRangesFrom(combinedDuties,'duty'),

_getNamedRangesFrom(scenario.sleep,'sleep'),

_getNamedRangesFrom(visibleAlertRanges.past.At,'at-threshold past'),
_getNamedRangesFrom(visibleAlertRanges.future.At,'at-threshold future'),

_getNamedRangesFrom(visibleAlertRanges.past.Above,'above-threshold past'),
_getNamedRangesFrom(visibleAlertRanges.future.Above,'above-threshold future'),

_getNamedRangesFrom(alertRanges.At,'at-threshold full'),
_getNamedRangesFrom(alertRanges.Above,'above-threshold full'),

incidents.map(function(d,i){return{
id:`incident-${i}`,
type:'point',
title:`Incident: ${_this6.incidentTypesByCode[d.code].description}`,
start:d.time,
className:'incident'}}));


}

return newData.map(function(d){return _.assign(d,{group:groupId,id:groupId+'-'+d.id})});
};_createClass(MultiForecastRowController,[{key:'currentBounds',get:function()

{
return _.pick(this.axisBounds,['start','end']);
}}]);return MultiForecastRowController}(ScheduleRowDirectiveController);


function _getNamedRangesFrom(data,name){
if(!data){
return[];
}

return data.map(function(d,i){return{
id:`${name}-${i}`,
start:d.start,
end:d.end,
className:name}});

}

function _formatTime(trip,key){
return Formatters.
formatInLocale(trip[key],`${Formatters.TwentyFourHourFormat} (Z)`,trip[key+'Timezone']).
replace(':00)',')');
}









module.exports=MultiForecastRowDirective;
//# sourceMappingURL=multiForecastRowDirective.js.map
